module.exports = __webpack_public_path__ + "img/projects3-wide.aed6a9cd.png";